export default __webpack_public_path__ + "static/media/chatdesk_admin_profile.5bc85309.svg";